import bsCustomFileInput from 'bs-custom-file-input'

document.addEventListener('turbo:load', () => bsCustomFileInput.init())
document.addEventListener('turbo:frame-render', () => bsCustomFileInput.init('turbo-frame .custom-file input[type="file"]', 'turbo-frame form'))
